/**
 * 配車をすべて解除
 */
 import Vue from 'vue'
 import * as httpConst from '../../../../../../constants/httpConst'

 const API_PATH = `${httpConst.DRIVER_ENDPOINT}/allocate/entries/drivers`

 const allocate_entry_driver_release = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    destroy ({ commit }, { driver_id, target_date }) {
      let params = { target_date: target_date }
      const api_path = `${API_PATH}/${driver_id}/releases`
      return new Promise( ( resolve ) => {
        Vue.$http.delete(api_path, { params: params }).then(data => {
          commit('snackbar/showInfo', { message: '解除しました' })
          resolve(data.content)
        })
      })
    },
  },
  mutations: {},
 }
 export default allocate_entry_driver_release
